import React, { useState } from "react";
import { Button, Menu, MenuItem, Paper } from "@material-ui/core/index";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default function PrmFilters(props) {
  const classes = styles();

  const [firstOpen, setFirstOpen] = useState(false);
  const [secondOpen, setSecondOpen] = useState(false);
  const [thirdOpen, setThirdOpen] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const { onMapChange, map } = props;

  const handleFirstClick = event => {
    setAnchorEl(event.currentTarget);
    setFirstOpen(true);
  };

  const handleFirstClose = () => {
    setAnchorEl(null);
    setFirstOpen(false);
  };

  const handleSecondClick = event => {
    setAnchorEl(event.currentTarget);
    setSecondOpen(true);
  };

  const handleSecondClose = map => {
    setAnchorEl(null);
    setSecondOpen(false);
    onMapChange(map);
  };

  const handleThirdClick = event => {
    setAnchorEl(event.currentTarget);
    setThirdOpen(true);
  };

  const handleThirdClose = () => {
    setAnchorEl(null);
    setThirdOpen(false);
  };

  return (
    <Paper square className={classes.container}>
      <Button
        className={classes.menuTitles}
        aria-controls="fade-menu"
        aria-haspopup="true"
        endIcon={<ArrowDropDownIcon className={classes.arrowDropDown} />}
        onClick={handleFirstClick}
      >
        Partenza
      </Button>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={firstOpen}
        onClose={handleFirstClose}
        variant={"selectedMenu"}
        //TransitionComponent={Fade}
      >
        <MenuItem onClick={handleFirstClose}>Partenza</MenuItem>
        <MenuItem onClick={handleFirstClose}>Arrivo</MenuItem>
      </Menu>
      <Button
        variant="outlined"
        className={classes.menuTitles}
        aria-controls="fade-menu"
        aria-haspopup="true"
        endIcon={<ArrowDropDownIcon className={classes.arrowDropDown} />}
        onClick={handleSecondClick}
      >
        {map}
      </Button>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={secondOpen}
        onClose={() => setSecondOpen(false)}
        //TransitionComponent={Fade}
      >
        <MenuItem onClick={() => handleSecondClose("Google")}>Google</MenuItem>
        <MenuItem onClick={() => handleSecondClose("Mapbox")}>Mapbox</MenuItem>
      </Menu>
      <Button
        className={classes.menuTitles}
        aria-controls="fade-menu"
        aria-haspopup="true"
        endIcon={<ArrowDropDownIcon className={classes.arrowDropDown} />}
        onClick={handleThirdClick}
      >
        Solo WCHC
      </Button>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={thirdOpen}
        onClose={() => setThirdOpen(false)}
        //TransitionComponent={Fade}
      >
        <MenuItem onClick={handleThirdClose}>WCHC</MenuItem>
        <MenuItem onClick={handleThirdClose}>WCHR</MenuItem>
        <MenuItem onClick={handleThirdClose}>WCHS</MenuItem>
        <MenuItem onClick={handleThirdClose}>DEAF</MenuItem>
        <MenuItem onClick={handleThirdClose}>BLIND</MenuItem>
        <MenuItem onClick={handleThirdClose}>STCR</MenuItem>
        <MenuItem onClick={handleThirdClose}>DPNA</MenuItem>
        <MenuItem onClick={handleThirdClose}>MEDA</MenuItem>
        <MenuItem onClick={handleThirdClose}>MAAS</MenuItem>
      </Menu>
    </Paper>
  );
}

const styles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.grey.main,
    paddingTop: 10,
    paddingBottom: 10,
    flexDirection: "row"
  },
  menuTitles: {
    width: "33.3%",
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderRadius: 0,
    textTransform: "none"
  },
  arrowDropDown: {
    color: theme.palette.grey.dark
  }
}));
